import React from "react";
import Icon from "../icon/icon";

import css from "./featured-icon.module.css";

const FeaturedIcon = ({ icon }) => {
  return (
    <div className={css.featuredIcon}>
      <Icon icon={icon} />
    </div>
  );
}

export default FeaturedIcon;
